<template>
  <div class="ams-home-notice-list" v-show="showNoticeList.length">
    <div class="notice-list-header">
      <span class="title">重要通知</span>
      <span class="count">{{ showNoticeList.length }}</span>
    </div>
    <div
      class="notice-carousel"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave">
      <div
        :aria-hidden="currentIndex !== index"
        v-for="(item, index) in showNoticeList"
        :key="item.id"
        class="notice-carousel-item"
        :style="animationStyle"
        :class="getItemCls(index)"
        @click="goNoticeDetail(item)">
        <div class="notice-content">{{ item.noticeTitle }}</div>
        <div class="notice-time">{{ date(item.publishDate) }}</div>
      </div>
    </div>
    <div class="show-more" @click="showMore">
      <span>查看更多</span>
      <i class="el-icon-arrow-right"></i></div>
    <NoticeDrawer ref="noticeDrawer" />
  </div>
</template>

<script>
  import mixins from 'public/mixins'
  import NoticeDrawer from './notice-drawer.vue'
  import { date } from 'public/utils/filter.js'

  const animationStyle = {
    transitionTimingFunction: 'cubic-bezier(0.34, 0.69, 0.1, 1)',
    transitionDuration: '500ms',
    animationTimingFunction: 'cubic-bezier(0.34, 0.69, 0.1, 1)',
    animationDuration: '500ms',
  }
  const CAROUSEL_INTERVAL = 5000
  const ANIMATION_DURATION = 500

  export default {
    components: {
      NoticeDrawer
    },
    mixins: [mixins],
    data () {
      return {
        noticeList: [],
        currentIndex: 0,
        previousIndex: undefined,
        animationStyle,
        animationTimer: 0,
        intervalTimer: null
      }
    },
    computed: {
      showNoticeList () {
        return this.noticeList.filter(v => v.status === 1)
      }
    },
    watch: {
      showNoticeList (list) {
        this.resetCarousel(list.length)
      }
    },
    created () {
      this.getNoticeList()
    },
    mounted () {
      this.startPlay()
    },
    activated () {
      this.getNoticeList()
      this.startPlay()
    },
    deactivated () {
      this.clearTimer()
    },
    beforeDestroy () {
      this.clearTimer()
    },
    methods: {
      date,
      getItemCls (index) {
        const prefixCls = 'notice-carousel-item'
        const isCurrent = this.currentIndex === index
        const isPrev = this.previousIndex === index
        return {
          [`${prefixCls}-current`]: isCurrent,
          [`${prefixCls}-slide-in`]: isCurrent,
          [`${prefixCls}-slide-out`]: isPrev,
        }
      },
      slideTo (targetIndex) {
        if (!this.animationTimer && targetIndex !== this.currentIndex) {
          this.previousIndex = this.currentIndex
          this.currentIndex = targetIndex
          this.animationTimer = window.setTimeout(() => {
            this.animationTimer = 0
          }, ANIMATION_DURATION)
        }
      },
      getValidIndex (i) {
        const indexNumber = +i
        const length = this.showNoticeList.length
        if (length === 0) return 0
        return typeof indexNumber === 'number' && !Number.isNaN(indexNumber)
          ? (indexNumber + length) % length
          : i
      },
      clearTimer () {
        if (this.intervalTimer) {
          window.clearInterval(this.intervalTimer)
          this.intervalTimer = null
        }
        if (this.animationTimer) {
          window.clearTimeout(this.animationTimer)
          this.animationTimer = 0
        }
      },
      resetCarousel (length) {
        this.currentIndex = 0
        this.previousIndex = undefined
        this.clearTimer()
        if (length > 1) {
          this.$nextTick(() => this.startPlay())
        }
      },
      startPlay () {
        this.clearTimer()
        if (this.showNoticeList.length <= 1) {
          return
        }
        this.intervalTimer = window.setInterval(() => {
          const nextIndex = this.getValidIndex(this.currentIndex + 1)
          this.slideTo(nextIndex)
        }, CAROUSEL_INTERVAL)
      },
      handleMouseEnter () {
        if (this.intervalTimer) {
          window.clearInterval(this.intervalTimer)
          this.intervalTimer = null
        }
      },
      handleMouseLeave () {
        this.startPlay()
      },
      showMore () {
        this.$refs.noticeDrawer.openDrawer(this.noticeList)
      },
      async getNoticeList () {
        const res = await this.$http('system.homeIndexNotice.searchUserNotice', {}, { appkey: '10124' })
        this.noticeList = res
      },
      goNoticeDetail (row) {
        window.erpOpen(row.relationLink, '_blank')
      },
      refresh () {
        this.getNoticeList()
      }
    }
  }
</script>

<style lang="scss" scoped>
.ams-home-notice-list {
  padding: 0 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.7);
  background: #ffffff;
  display: flex;
  align-items: center;
  height: 42px;
  margin-bottom: 12px;
  .notice-list-header {
    display: flex;
    align-items: center;
    color: #6C3CF4;
    background: rgba(243, 239, 254, 1);
    width: 78px;
    height: 24px;
    border-radius: 12px;
    justify-content: center;
    .title {
      margin-right: 2px;
    }
  }
  .notice-carousel {
    position: relative;
    height: 28px;
    overflow: hidden;
    flex: 1;
    min-width: 0;
    @keyframes slideIn {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }

    @keyframes slideOut {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(-100%);
      }
    }

    &-item {
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 8px;
      width: 100%;
      height: 100%;
      font-size: 12px;
      cursor: pointer;
      .notice-content {
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .notice-time {
        flex-shrink: 0;
        color: rgba(160, 158, 191, 1);
        width: 115px;
        min-width: 72px;
        text-align: end;
      }
      &-current {
        z-index: 1;
      }
      &-slide-out {
        display: flex !important;
        animation: slideOut;
      }
      &-slide-in {
        display: flex;
        animation: slideIn;
      }
      &-readed {
        i {
          color: #FF5555;
        }
      }
    }

    > *:not(.notice-carousel-item-current) {
      display: none;
      visibility: hidden;
    }
  }
  .show-more {
    display: flex;
    align-items: center;
    text-align: center;
    color: #6C3CF4;
    cursor: pointer;
    padding-left: 8px;
    height: 8px;
    line-height: 8px;
    border-left: 1px solid rgba(68, 62, 82, 0.1);
  }
  .more-btn {
    text-align: center;
    font-size: 12px;
    color: #888EA6;
    cursor: pointer;
    height: 14px;
    position: absolute;
    bottom: 14px;
    width: 64px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/home-notice/notice-list.vue